export const FIAT_DECIMALS = 4;
